<template>
    <div>
        <p class="text-small text-primary font-weight-medium mb-3">
            <v-icon class="me-2" color="secondary" size="20">icon-chart</v-icon>اختصاص محصول به مشتریان و کاربران سازمانی
        </p>
        <v-skeleton-loader v-if="skeleton" class="mx-auto" height="350" type="ossein"></v-skeleton-loader>
        <apexchart
            :options="chartOptions"
            :series="series"
            height="350"
            v-else
        ></apexchart>
    </div>
</template>
<script>
import fa from "apexcharts/dist/locales/fa.json";
import VueApexCharts from "vue3-apexcharts";
export default {
    components: {
        apexchart: VueApexCharts,
    },
    data() {
        return {
            skeleton: true,
            series: [],
            chartOptions: {
                chart: {
                    locales: [fa],
                    defaultLocale: "fa",
                    stacked: true,
                    type: "bar",
                },
                colors: ["#008FFB", "#FF4560"],
                plotOptions: {
                    bar: {
                        horizontal: true,
                        barHeight: "80%",
                    },
                },
                dataLabels: {
                    enabled: false,
                },
                legend: {
                    fontFamily: "iransans",
                    horizontalAlign: "right",
                    fontWeight: 500,
                    markers: {
                        width: 9,
                        height: 9,
                        offsetY: 2,
                        offsetX: 4,
                    },
                },
                stroke: {
                    width: 1,
                    colors: ["#fff"],
                },
                grid: {
                    xaxis: {
                        lines: {
                            show: false,
                        },
                    },
                },
                yaxis: {
                    forceNiceScale: true,
                    labels: {
                        style: {
                            fontFamily: "iransans",
                        },
                    },
                },
                tooltip: {
                    shared: false,
                    style: {
                        fontFamily: "iransans",
                    },
                    y: {
                        formatter: function (val) {
                            return Math.abs(val);
                        },
                    },
                },
                xaxis: {
                    categories: [],
                    labels: {
                        style: {
                            fontFamily: "iransans",
                        },
                        formatter: function (val) {
                            return Math.abs(Math.round(val));
                        },
                    },
                },
            },
        };
    },
    methods: {
        getReportServiceUser() {
            this.$reportServiceUser().then((res) => {
                if (res && res.status == "OK") {
                    this.series = []
                    this.chartOptions.xaxis.categories = []
                    this.series.push(
                        {
                            name: "مشتریان",
                            data: [
                                ...res.data.map((item) => item.customers * -1),
                            ],
                        },
                        {
                            name: "کاربران سازمانی",
                            data: [...res.data.map((item) => item.employees)],
                        }
                    );
                    this.chartOptions.xaxis.categories.push(
                        ...res.data.map((item) => item.x)
                    );
                    var max = Math.max(
                        ...res.data.map((item) => item.employees),
                        ...res.data.map((item) => item.customers)
                    );
                    this.chartOptions.yaxis.max = max + 1;
                    this.chartOptions.yaxis.min = -max - 1;
                    this.skeleton = false;
                }
            });
        },
    },
    mounted() {
        this.getReportServiceUser();
    },
};
</script>
